/* eslint-disable */
/* tslint:disable */

import request, { ContentType, RequestParams } from './httpClient'
import { DomainConsultListResp, GetAdminConsultListParams, WebResp } from './types'

/**
 * @description 商机列表
 *
 * @tags AdminConsultV1
 * @name GetAdminConsultList
 * @summary 商机列表
 * @request GET:/api/v1/admin/consult
 * @response `200` `(WebResp & {
    data?: DomainConsultListResp,

})` OK
 */

export const getAdminConsultList = (query: GetAdminConsultListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainConsultListResp
    }
  >({
    path: `/api/v1/admin/consult`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
